import React from 'react';
import { TStep6Info } from '../../../types';
import UploadInput from '../../global/UploadInput';

import './businessRegistration.css';

type TProps = {
  info: TStep6Info;
  setInfo: React.Dispatch<React.SetStateAction<TStep6Info[]>>;
  index_: number;
  data: TStep6Info[];
};
const BusinessUploadForm = ({ data, index_, info, setInfo }: TProps) => {
  return (
    <div className='stepSix formCont'>
      <div className='mb-[27px]'>
        <UploadInput
          label='Passport Photograph'
          value={info?.passport}
          setInfo={setInfo}
          name={'passport'}
          data={data}
          index_={index_}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            const newState = data?.map((obj, index) => {
              if (index === index_) {
                return { ...obj, passport: e?.target?.files?.[0] };
              }

              return obj;
            });

            setInfo(newState);
          }}
        />
      </div>
      <div className='mb-[27px]'>
        <UploadInput
          value={info?.idCard}
          index_={index_}
          data={data}
          name={'idCard'}
          setInfo={setInfo}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            const newState = data?.map((obj, index) => {
              if (index === index_) {
                return { ...obj, idCard: e?.target?.files?.[0] };
              }

              return obj;
            });

            setInfo(newState);
          }}
          label='Valid ID Card'
        />
      </div>
      <div className='mb-[27px]'>
        <UploadInput
          value={info?.proofOfAddress}
          name={'proofOfAddress'}
          index_={index_}
          setInfo={setInfo}
          data={data}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            const newState = data?.map((obj, index) => {
              if (index === index_) {
                return { ...obj, proofOfAddress: e?.target?.files?.[0] };
              }

              return obj;
            });

            setInfo(newState);
          }}
          label='Proof of address'
        />
      </div>
      <div className='mb-[27px]'>
        <UploadInput
          value={info?.signature}
          index_={index_}
          name={'signature'}
          data={data}
          setInfo={setInfo}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            const newState = data?.map((obj, index) => {
              if (index === index_) {
                return { ...obj, signature: e?.target?.files?.[0] };
              }

              return obj;
            });

            setInfo(newState);
          }}
          label='Signature specimen'
        />
      </div>
    </div>
  );
};

export default BusinessUploadForm;
